module.exports = __webpack_public_path__ + "static/media/CormorantGaramond-SemiBoldItalic.a4b0c8ab.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/CormorantGaramond-SemiBoldItalic.ttf
// module id = 2937
// module chunks = 51